export default __webpack_public_path__ + "static/media/icon-dashboards.0773a5f8.svg";